export default class TypPoziadavkyService {

  constructor(server){
    this.server = server;
  }

  list(){
    return this.server("TypPoziadavky.list").then(r => r.result);
  }

  save(item){
    return this.server("TypPoziadavky.create", {nazov: item.nazov, zodpovednyUzivatel: item.zodpovednyUzivatel, externy: item.externy, sms: item.sms, email: item.email, acl: item.acl});
  }

  update(item){
    return this.server("TypPoziadavky.update", {id: item.id, nazov:item.nazov, zodpovednyUzivatel: item.zodpovednyUzivatel, externy: item.externy, sms: item.sms, email: item.email, acl: item.acl}); 
  }

  remove(item){
    return this.server("TypPoziadavky.delete", {id: item.id});
  }


}


// WEBPACK FOOTER //
// ./src/services/TypPoziadavkyService.js